export function validateDestination (locationName: string) {
  return locationName.includes('-MERMA-')
}
